import { IGenerator } from './interfaces/IGenerator.js';

/**
 * Base generator implementing common generation logic (DRY principle)
 */
export class BaseGenerator extends IGenerator {
  constructor(config) {
    super();
    this.config = config;
  }

  /**
   * Generate random number within range
   */
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Generate random digit string
   */
  randomDigits(length) {
    return Array.from({ length }, () => this.randomInt(0, 9)).join('');
  }

  /**
   * Generate random letter
   */
  randomLetter(uppercase = true) {
    const letters = uppercase ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' : 'abcdefghijklmnopqrstuvwxyz';
    return letters[this.randomInt(0, letters.length - 1)];
  }

  /**
   * Pad number with leading zeros
   */
  padZero(num, length) {
    return num.toString().padStart(length, '0');
  }
}